import React from 'react';
import i18next from 'i18next';
import { authRoles, PERMISSION } from 'app/auth';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'pharmacy', en);

const CreatePharmacyConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Create Pharmacy',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.PHARMACY,
  permission: PERMISSION.CREATE,
  routes: [
    {
      path: '/pharmacy/create',
      component: React.lazy(() => import('./CreatePharmacy')),
    },
  ],
};

export default CreatePharmacyConfig;
